var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbOpenPopupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-open-popup-icon_svg__clip0_4506_33531)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.7 2.1A1.4 1.4 0 012.1.7h2.8a.7.7 0 110 1.4H2.1v9.8h9.8V9.1a.7.7 0 111.4 0v2.8a1.4 1.4 0 01-1.4 1.4H2.1a1.4 1.4 0 01-1.4-1.4V2.1zm7.7 0a.7.7 0 110-1.4h4.2a.7.7 0 01.7.7v4.2a.7.7 0 11-1.4 0V3.09L6.095 8.895a.7.7 0 01-.99-.99L10.91 2.1H8.4z",
    fill: "#58647A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-open-popup-icon_svg__clip0_4506_33531"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}

export default SvgIbOpenPopupIcon;